module.exports = __webpack_public_path__ + "img/download_app_store.3a1def64.png";